enum AddressTypeV4Enum {
	RESIDENTIAL = 3,
	COMMERCIAL = 2,
	OTHERS = 99,
	BILLING = 1,
}

type AddressV4ItemRequest = {
	sequence?: number;
	type: number;
	zipCode: string;
	state: string;
	city: string;
	district: string;
	street: string;
	streetType: string;
	streetNumber: string;
	complement?: string;
	latitude?: string;
	longitude?: string;
	descriptionOthers?: string;
	dependentCodes?: string[];
	flPrincipal?: boolean;
};

type PostBeneficiaryAddressV4Request = {
	addresses: AddressV4ItemRequest[];
	signal?: AbortSignal;
};

interface PostBeneficiaryAddressV4 {
	post: (params: PostBeneficiaryAddressV4Request) => Promise<void>;
}

export {AddressTypeV4Enum};
export type {AddressV4ItemRequest, PostBeneficiaryAddressV4Request, PostBeneficiaryAddressV4};
